import { lazy } from 'react';

const RedirectToLogin = lazy(() => import("../RedirectToLogin"));
const Login = lazy(() => import("../pages/Login"));
const ContactPage = lazy(() => import("../pages/ContactUs"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));

export const publicRoutesList = [
    // {
    //     path: "/",
    //     element: RedirectToLogin
    // },
    {
        path: "/login",
        element: Login
    },
    {
        path: "/contact-us",
        element: ContactPage
    },
    {
        path: "/forgot-password",
        element: ForgotPassword
    },
    {
        path: "/reset-password",
        element: ResetPassword
    }
];